import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { PageType } from '../page-edit-screen/page-type';
import { apiErrorMessage } from '../shared/functions/general-api-error-handling';
import { PageApiService } from './page-api.service';
import * as Action from './page-screen.actions';

@Injectable()
export class PageScreenEffects {
  constructor(private readonly actions$: Actions, private readonly pageApiService: PageApiService, private readonly router: Router) {}

  public loadPage$ = createEffect(() =>
    this.actions$.pipe(
      ofType(Action.loadCxbPageScreen),
      switchMap(() =>
        this.pageApiService.listAllPages$().pipe(
          map((result) =>
            Action.loadCxbPageScreenSuccess({
              pages: result,
            })
          ),
          catchError((error) => of(Action.loadCxbPageScreenFail(apiErrorMessage(error))))
        )
      )
    )
  );

  public createNewRedeemPage$ = createEffect(() =>
    this.actions$.pipe(
      ofType(Action.createCxbRedeemPage),
      switchMap(({ data }) => {
        return this.pageApiService.createRedeemPage$(data).pipe(
          switchMap((result) => of(Action.createCxbPageSuccess({ page: result, pageType: PageType.redeem }))),
          catchError((error) => of(Action.createCxbPageFail(apiErrorMessage(error))))
        );
      })
    )
  );

  public createNewContentPage$ = createEffect(() =>
    this.actions$.pipe(
      ofType(Action.createCxbContentPage),
      switchMap(({ data }) => {
        return this.pageApiService.createContentPage$(data).pipe(
          switchMap((result) => of(Action.createCxbPageSuccess({ page: result, pageType: PageType.content }))),
          catchError((error) => of(Action.createCxbPageFail(apiErrorMessage(error))))
        );
      })
    )
  );

  public createNewGenrePage$ = createEffect(() =>
    this.actions$.pipe(
      ofType(Action.createCxbGenrePage),
      switchMap(({ data }) => {
        return this.pageApiService.createGenrePage$(data).pipe(
          switchMap((result) => of(Action.createCxbPageSuccess({ page: result, pageType: PageType.genre }))),
          catchError((error) => of(Action.createCxbPageFail(apiErrorMessage(error))))
        );
      })
    )
  );

  public createNewPageSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(Action.createCxbPageSuccess),
        tap(({ page, pageType }) => {
          const draftPageVersionId = page.draftPageId;
          if (draftPageVersionId) {
            this.router.navigate([pageType.routePath, draftPageVersionId]);
          }
        })
      ),
    { dispatch: false }
  );
}
